import Button from "../Button";
import { fontSizes } from "../../constants/constants";
import Icons from "../../assets/icon";
import Text from "../Text";
import Functions from "./index.function";
const FileUpload = ({
  className,
  text,
  accept,
  multiple = false,
  handleChange,
  loading,
  onClick,
}) => {
  const { TextWeight, fileInputRef, handleClick } = Functions(onClick);
  return (
    <div className={`flex justify-between items-center ${className}`}>
      <Text
        text={text}
        color="text-secondary"
        size={fontSizes.h30}
        isTruncate={false}
        weight={TextWeight.Onest_semiBold}
      />
      {/* Hidden File Input */}
      <input
        type="file"
        accept={accept}
        ref={fileInputRef}
        multiple={multiple}
        onChange={handleChange}
        className="hidden"
      />

      {/* Custom UI */}
      <Button
        text="Add"
        type={"button"}
        onClick={handleClick}
        bgColor="bg-goldMetallic"
        color="text-secondary"
        className="w-32 py-1 sm:py-1 lg:py-2 sm:w-28 lg:w-36 sm:gap-2 lg:gap-4 rounded-full"
        classList="w-3 sm:w-3.5 lg:w-4"
        textSize={fontSizes.h16}
        icon={Icons.plusIcon}
        weight={TextWeight.Onest_semiBold}
        loading={loading}
        isDisabled={loading}
      />
    </div>
  );
};

export default FileUpload;
